<template>
    <div class="prop-box">

        <el-form label-width="auto">
            <el-form-item label="标题">
                <el-input v-model="myBottomTab.titlebar.title"></el-input>
            </el-form-item>

            <el-form-item label="标题栏">
                <el-radio-group v-model="myBottomTab.titlebar.exist">
                    <el-radio :label="1">存在</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="左icons">
                <el-autocomplete clearable v-model="queryLeft" :fetch-suggestions="querySearch" placeholder="搜索/选择素材组"
                    @select="(item) => handleSelect(item, 'left')" @clear="onClear('left')"></el-autocomplete>
            </el-form-item>

            <el-form-item label="右icons">
                <el-autocomplete clearable v-model="queryRight" :fetch-suggestions="querySearch" placeholder="搜索/选择素材组"
                    @select="(item) => handleSelect(item, 'right')" @clear="onClear('right')"></el-autocomplete>
                <div></div>
            </el-form-item>

        </el-form>

    </div>
</template>

<script>
import { GetMaterialGroupList } from '@/request/api'
export default {
    name: "TitleBarProp",
    components: {
    },
    props: ['obj'],
    data() {
        return {
            myBottomTab: this.obj,
            queryLeft: '',
            queryRight: ''
        }
    },
    mounted() {
        this.queryLeft = this.myBottomTab.ignore.top_left_source_name
        this.queryRight = this.myBottomTab.ignore.top_right_source_name
    },
    methods: {

        /**
         * 搜索素材组
         */
        querySearch(queryString, cb) {
            console.log('querySearch', queryString)
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetMaterialGroupList(params)
                .then(data => {
                    var list = []
                    if (data.list) {
                        list = data.list.map(item => {
                            return {
                                value: item.name,
                                id: item.materialGroupID
                            }
                        })
                    }
                    cb(list)
                })
                .catch(error => {
                    console.error('素材组列表', error)
                })
        },
        /**
         * 选中素材组
         */
        handleSelect(item, type) {
            if (type == 'left') {
                this.myBottomTab.top_left_source = {
                    type: "material_group",
                    params: {
                        "material_group_id": ''
                    }
                }
                this.myBottomTab.top_left_source.params.material_group_id = item.id
                this.myBottomTab.ignore.top_left_source_name = item.value
            } else if (type == 'right') {
                this.myBottomTab.top_right_source = {
                    type: "material_group",
                    params: {
                        "material_group_id": ''
                    }
                }
                this.myBottomTab.top_right_source.params.material_group_id = item.id
                this.myBottomTab.ignore.top_right_source_name = item.value
            }
        },
        /**
         * 清除输入框
         */
        onClear(type) {
            if (type == 'left') {
                this.myBottomTab.top_left_source.params.material_group_id = ''
                this.myBottomTab.ignore.top_left_source_name = ''
            } else if (type == 'right') {
                this.myBottomTab.top_right_source.params.material_group_id = ''
                this.myBottomTab.ignore.top_right_source_name = ''
            }
        }
    }
}
</script>

<style scoped lang="less">
.tab-item {
    margin-bottom: 15px;
}

.tab-header {
    position: relative;
    height: 30px;

    .title {
        font-size: medium;
        font-weight: bold;
    }

    .menu {
        position: absolute;
        top: 0;
        right: 10px;
    }
}

.color-wrapper {
    width: 80%;
    height: 50px;
    margin-left: 10%;
}

:deep(.el-color-picker) {
    width: 80%;
    height: 50px;
}

:deep(.el-color-picker__trigger) {
    width: 100%;
    height: 100%;
    padding: 0;
}

.color-box {
    text-align: center;

    p {
        color: gray;
        font-size: small;
    }
}
</style>